export const contentTableConfig = {
  title: '删除列表',
  propList: [
    {prop: 'corpName', label: '主体名称', minWidth: '80'},
    {prop: 'empId', label: '企微账号', minWidth: '80'},
    {prop: 'usedBy', label: '使用人', minWidth: '80'},
    {prop: 'userName', label: '客户昵称', minWidth: '80'},
    {prop: 'userId', label: '客户ID', minWidth: '80'},
    {prop: 'tags', label: '标签', minWidth: '120'},
    {prop: 'custAlreadyDeleted', label: '删除说明', minWidth: '80', slotName: 'custAlreadyDeleted'},
    {prop: 'deletedAt', label: '删除时间', minWidth: '80'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
